import React, { lazy } from "react";
import routes from "constants/routes";
import { IRouteConfig } from "components/route/RouteMap";

const ROUTES: IRouteConfig[] = [
  {
    path: routes.OVERVIEW,
    exact: true,
    component: lazy(() => import("./overview/OverviewView")),
  },
  {
    path: routes.MONITOR,
    exact: true,
    component: lazy(() => import("./monitor/Monitor")),
  },
  {
    path: routes.DEVICE_ADD,
    exact: true,
    component: lazy(() => import("./device/add/DeviceAddView")),
  },
  {
    path: routes.DEVICE_DETAIL,
    exact: true,
    component: lazy(() => import("./device/detail/DeviceDetail")),
  },
  {
    path: routes.DEVICE_LIST,
    exact: true,
    component: lazy(() => import("./device/list/DeviceListView")),
  },
  {
    path: routes.CREDIT_LIST,
    exact: true,
    component: lazy(() => import("./credit/list/CreditListView")),
  },
  {
    path: routes.USER_LIST,
    exact: true,
    component: lazy(() => import("./user/list/UserListView")),
  },
  {
    path: routes.USER_INVITATION_LIST,
    exact: true,
    component: lazy(() => import("./user/invitation/UserInvitationListView")),
  },
  {
    path: routes.DATA_LIST,
    exact: true,
    component: lazy(() => import("./data/DataView")),
  },
  {
    redirect: true,
    path: routes.OVERVIEW,
  },
];

export default ROUTES;
